export default __webpack_public_path__ + "static/smoke-0-7fb6b2d8d53f92aeca8bfb0d71964b2f.jpg";